module.exports = __webpack_public_path__ + "img/sponsorAM2024.d0ac792c.png";